import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'state/store';
import {
  IL_EMBED_CONFIG_READY_EVENT,
  resolveGoogleMapsApiKey,
} from './resolveGoogleMapsApiKey';

/**
 * Resolves the Maps key from embed SDK globals and/or Redux clientConfig,
 * re-checking when the bootstrap fires `il-embed-config-ready`.
 */
export function useGoogleMapsApiKey(): string {
  const reduxKey = useSelector(
    (state: RootState) => state.clientConfig.data?.googleMapsBrowserJSApiKey || '',
  );
  const [key, setKey] = useState(() => resolveGoogleMapsApiKey(reduxKey));

  useEffect(() => {
    setKey(resolveGoogleMapsApiKey(reduxKey));
  }, [reduxKey]);

  useEffect(() => {
    if (key) return undefined;
    const onReady = () => setKey(resolveGoogleMapsApiKey(reduxKey));
    window.addEventListener(IL_EMBED_CONFIG_READY_EVENT, onReady);
    return () => window.removeEventListener(IL_EMBED_CONFIG_READY_EVENT, onReady);
  }, [key, reduxKey]);

  return key;
}
